// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__34970","image":"Header_image__2U4zg","name":"Header_name__gicB0","info":"Header_info__2isCf","infoRow":"Header_infoRow__vb3Fa"};